var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{attrs:{"gridKey":"UpdatesToRemovePortal","columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"main-grid-height":"475px"},on:{"grid-ready":function (gridKey) { return _vm.$emit('grid-ready', gridKey); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }